import * as $ from 'jquery';
// @ts-ignore
import * as Flickity from 'flickity-imagesloaded';
import { isMobile } from './components/media-query';

(<any>window).jQuery = $;
(<any>window).$ = $;
/**
 * Generic Javascript Bootstraping
 */
import Select from './components/select';

import BackToTop from './components/back-to-top';
import LazyLoadScript from './components/lazy-load/lazy-load-scripts';
import LazyLoadImages from './components/lazy-load/lazy-load-images';
import InfographicFlow from './components/infographic/infographic-flow';
import CtaLink from './components/cta-as-link';
import YoutubeVideo from './components/video/youtube-video';
import Toggle from './components/toggle';
import Navigation from './components/navigation';
import Modal from './components/modal';
import Tab from './components/tab';
import OneTrustCookieYoutube from './components/oneTrusCookieYoutube';
import TopSearch from './components/top-search/top-search';
import MailTo from './components/mailto';
import Carousel from './components/carousel/carousel';

const getStockGraph = () => {
  const stockGraph = $('.js-stock-graph');
  if (stockGraph.length) {
    return import(/* webpackChunkName: "stock-graph" */ './components/highcharts/stock-graph')
      .then(({ default: StockGraph }) => {
        return new StockGraph();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getInfographic = () => {
  const infographic = $('.Infographic');
  if (infographic.length) {
    return import(/* webpackChunkName: "infographic" */ './components/infographic/infographic')
      .then(({ default: Infographic }) => {
        return new Infographic();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getTableGraph = () => {
  if ($('.js-table-graph').length && !isMobile()) {
    return import(/* webpackChunkName: "table-graph" */ './components/table-graph')
      .then(({ default: TableGraph }) => {
        return new TableGraph();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getVideos = () => {
  if ($('.video-player').length) {
    return import(/* webpackChunkName: "video-player" */ './components/video/video-player')
      .then(({ default: VideoPlayerWrapper }) => {
        return new VideoPlayerWrapper();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getAnimations = () => {
  if(document.querySelectorAll('[data-aos]').length) {
    return import(/* webpackChunkName: "animationAOS" */ './components/animations')
      .then(({ default: Animations }) => {
        return new Animations();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getBrandList = () => {
  if ($('.brand-list').length) {
    return import(/* webpackChunkName: "brandList" */ './components/brand-list')
      .then(({ default: BrandList }) => {
        return new BrandList();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getCardCollection = () => {
  if ($('.js-card-carousel').length) {
    return import(/* webpackChunkName: "cardCollection" */ './components/card/card-collections')
      .then(({ default: CardCollection }) => {
        return new CardCollection('.js-card-carousel');
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getFormValidation = () => {
  if ($('[data-form="validator"]').length) {
    return import(/* webpackChunkName: "form-validation" */ './components/forms/form-validation')
      .then(({ default: FormValidation }) => {
        return new FormValidation('[data-form="validator"]');
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getFormAnimation = () => {
  if ($('.hype-innovation-form').length) {
    return import(/* webpackChunkName: "form-validation" */ './components/forms/form-animation')
      .then(({ default: FormAnimation }) => {
        return new FormAnimation();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getCarousel = () => {
  if (Array.from(document.querySelectorAll('.js-carousel')).length) {
    return import(/* webpackChunkName: "carousel" */ './components/carousel/carousel')
      .then(({ default: Carousel }) => {
        return new Carousel(Flickity);;
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getHeroBrandsSlider = () => {
  if ($('.js-brands-carousel').length) {
    return import(/* webpackChunkName: "hero-brands-slider" */ './components/card/hero-brands-slider')
      .then(({ default: HeroBrandsSlider }) => {
        return new HeroBrandsSlider();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

const getApp = () => {
  if ($('#app').length) {
    return import(/* webpackChunkName: "app" */ './app/app')
      .then(({ default: App }) => {
        const app = new App();
        return app.init();
      })
      .catch((error) => 'An error occurred while loading the component');
  }
}

getApp();
getHeroBrandsSlider();

(<any>window).Essity = {};
(<any>window).Essity.youtubeVideo = new YoutubeVideo();

$(() => {
  new LazyLoadImages();
  new BackToTop();
  new LazyLoadScript('.g-recaptcha', 'https://www.google.com/recaptcha/api.js?hl=');
  new InfographicFlow();
  new CtaLink();
  new Navigation();
  new Modal();
  new Tab();
  new TopSearch();
  new MailTo();
  getStockGraph();
  getInfographic();
  getTableGraph();
  getVideos();
  getAnimations();
  getBrandList();
  getCardCollection();
  getFormValidation();
  getFormAnimation();
  getCarousel();
});

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    new Select();
    new Toggle();
    if ((<any>window).OneTrust && (<any>window).OnetrustActiveGroups) {
    	new OneTrustCookieYoutube();
    }
  }
};
